import { Tab } from 'semantic-ui-react';
import DataSourceBrowse from './Browse';
import DataSourceTransactions from './Transactions/List';
import ManageSource from './manageSource';
import styles from './datasource.module.scss';

function DataSource({ account }) {
    const panes = [
        {
            menuItem: 'Browse', render: () =>
                <Tab.Pane> <DataSourceBrowse account={account} /> </Tab.Pane>
        },
        {
            menuItem: 'Transactions', render: () => <Tab.Pane>
                <DataSourceTransactions account={account} />
            </Tab.Pane>
        },
        {
            menuItem: 'Inspector', render: () => <Tab.Pane>
                <ManageSource openManageSource={true} account={account} />
            </Tab.Pane>
        },
    ]
    return (
        <div className={styles.datasource}>
            <div className={styles.title}> {account && account.name}</div>
            <Tab panes={panes} />
        </div>)
}

export default DataSource;